/** URL ?key= 검증 후 세션 유지 (주소창에서는 쿼리 제거) */
export const ACCESS_KEY_PARAM = 'key';
export const ACCESS_KEY_SESSION_FLAG = 'pool_app_access_granted_v1';

export function hasValidAccessSession(): boolean {
  try {
    return sessionStorage.getItem(ACCESS_KEY_SESSION_FLAG) === '1';
  } catch {
    return false;
  }
}

export function grantAccessSession(): void {
  try {
    sessionStorage.setItem(ACCESS_KEY_SESSION_FLAG, '1');
  } catch {
    // ignore
  }
}

/** 관제 메인에서 연 팝업 — 부모 탭의 접근 키 세션을 같은 출처에서 복사 */
export function tryInheritAccessSessionFromOpener(): boolean {
  if (hasValidAccessSession()) {
    return true;
  }
  try {
    const opener = window.opener;
    if (!opener || opener.closed) {
      return false;
    }
    if (opener.location.origin !== window.location.origin) {
      return false;
    }
    const parentGranted =
      opener.sessionStorage.getItem(ACCESS_KEY_SESSION_FLAG) === '1';
    if (parentGranted) {
      grantAccessSession();
      return true;
    }
  } catch {
    // opener 접근 불가
  }
  return false;
}

export function revokeAccessSession(): void {
  try {
    sessionStorage.removeItem(ACCESS_KEY_SESSION_FLAG);
  } catch {
    // ignore
  }
}

/** 개발용: 서버 미응답 시 .env 폴백 */
export function getEnvAccessKeyFallback(): string {
  return String(process.env.REACT_APP_ACCESS_KEY || '').trim();
}
